/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyTaxonomy = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyTaxonomy model module.
   * @module model/StrategyTaxonomy
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyTaxonomy</code>.
   * @alias module:model/StrategyTaxonomy
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>StrategyTaxonomy</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyTaxonomy} obj Optional instance to populate.
   * @return {module:model/StrategyTaxonomy} The populated <code>StrategyTaxonomy</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('DescriptionFI')) {
        obj['DescriptionFI'] = ApiClient.convertToType(data['DescriptionFI'], 'String');
      }
      if (data.hasOwnProperty('DescriptionEN')) {
        obj['DescriptionEN'] = ApiClient.convertToType(data['DescriptionEN'], 'String');
      }
      if (data.hasOwnProperty('DescriptionSE')) {
        obj['DescriptionSE'] = ApiClient.convertToType(data['DescriptionSE'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescriptionFI')) {
        obj['DefaultDescriptionFI'] = ApiClient.convertToType(data['DefaultDescriptionFI'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescriptionEN')) {
        obj['DefaultDescriptionEN'] = ApiClient.convertToType(data['DefaultDescriptionEN'], 'String');
      }
      if (data.hasOwnProperty('DefaultDescriptionSE')) {
        obj['DefaultDescriptionSE'] = ApiClient.convertToType(data['DefaultDescriptionSE'], 'String');
      }
      if (data.hasOwnProperty('DescriptionOverride')) {
        obj['DescriptionOverride'] = ApiClient.convertToType(data['DescriptionOverride'], 'String');
      }
      if (data.hasOwnProperty('IsActive')) {
        obj['IsActive'] = ApiClient.convertToType(data['IsActive'], 'Boolean');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} DescriptionFI
   * @default ''
   */
  exports.prototype['DescriptionFI'] = '';
  /**
   * @member {String} DescriptionEN
   * @default ''
   */
  exports.prototype['DescriptionEN'] = '';
  /**
   * @member {String} DescriptionSE
   * @default ''
   */
  exports.prototype['DescriptionSE'] = '';
  /**
   * @member {String} DefaultDescriptionFI
   * @default ''
   */
  exports.prototype['DefaultDescriptionFI'] = '';
  /**
   * @member {String} DefaultDescriptionEN
   * @default ''
   */
  exports.prototype['DefaultDescriptionEN'] = '';
  /**
   * @member {String} DefaultDescriptionSE
   * @default ''
   */
  exports.prototype['DefaultDescriptionSE'] = '';
  /**
   * @member {String} DescriptionOverride
   * @default ''
   */
  exports.prototype['DescriptionOverride'] = '';
  /**
   * @member {Boolean} IsActive
   * @default false
   */
  exports.prototype['IsActive'] = false;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


